import { AQISensorObservation } from 'features/aqiSensors/aqiSensors.types';
import { AQI_COLOR_STOPS } from 'features/mapping/components/layers/PurpleAirLayer/AQILayer.constants';
import { TFunction } from 'i18next';
import { subHours } from 'date-fns';
import { getInterpolatedColor } from 'features/mapping/mapping.utils';

export const getLatestObservation = (
  observations: AQISensorObservation[],
): AQISensorObservation | null => {
  if (observations.length === 0) return null;

  // Sort observations by timestamp (newest first)
  const sortedObs = [...observations].sort(
    (a, b) => b.timestamp.getTime() - a.timestamp.getTime(),
  );

  return sortedObs[0];
};

export const getLevelFromAQI = (t: TFunction, aqi: number): string => {
  const levels = [
    { max: 50, key: 'good' },
    { max: 100, key: 'moderate' },
    { max: 150, key: 'unhealthySensitive' },
    { max: 200, key: 'unhealthy' },
    { max: 300, key: 'veryUnhealthy' },
    { max: Infinity, key: 'hazardous' },
  ];

  const level = levels.find(({ max }) => aqi <= max) ?? levels.at(-1)!;

  return t(`aqiSensors.levels.${level.key}`);
};

export const getLevelColorFromAQI = (aqi: number): string => {
  return getInterpolatedColor(aqi, AQI_COLOR_STOPS, 'hcl');
};

export const getLast24HoursObservations = (
  observations: AQISensorObservation[],
): {
  minTimestamp: Date;
  maxTimestamp: Date;
  observations: AQISensorObservation[];
} => {
  const now = new Date();
  const past24Hours = subHours(now, 24);
  const filtered = observations.filter(
    (obs) => obs.timestamp >= past24Hours && obs.timestamp <= now,
  );
  return {
    minTimestamp: past24Hours,
    maxTimestamp: now,
    observations: filtered,
  };
};
